export default {
  customSearchResults: [],
  selectedSearchVariant: {},
  isLoading: false,
  searchVariants: [],
};
